import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { LOAN_GROUPS, LOAN_GROUPS_IDS } from '@/helpers/constants';
import s from './index.module.scss';

export const Filter = ({ loans = [], group, onClick }) => {
  const { t } = useTranslation('loans');
  const { t: tConstants } = useTranslation('constants');

  if (loans.length < 2) {
    return null;
  }

  const LOAN_GROUPS_T = LOAN_GROUPS(tConstants);
  return (
    <div className={s.wrapper}>
      <h2 className="f-article-accent">{t('loan_info.more_details_about')}</h2>
      <div className={s.list_wrapper}>
        <div className={s.list}>
          <div
            onClick={() => onClick()}
            className={classnames(s.item, !group && 'active')}
          >
            {t('loan_info.all_loan_groups')}
          </div>
          <div
            onClick={() => onClick(LOAN_GROUPS_IDS.conservative.id)}
            className={classnames(
              s.item,
              LOAN_GROUPS_IDS.conservative.id === group && 'active',
            )}
          >
            {LOAN_GROUPS_T.conservative.full_name}
          </div>
          <div
            onClick={() => onClick(LOAN_GROUPS_IDS.moderate.id)}
            className={classnames(
              s.item,
              LOAN_GROUPS_IDS.moderate.id === group && 'active',
            )}
          >
            {LOAN_GROUPS_T.moderate.full_name}
          </div>
        </div>
      </div>
    </div>
  );
};
